import { Input, Component } from "@angular/core";
import { CodePanel, AbstractCodeValue } from "../../../models";
import { BaseComponent } from "../../../baseComponent";
import { ProductDataStore } from "../../../providers/productData";
import { PageStore } from "../../../providers/page";
import { ConfPageSessionService } from "../../../../configurator/providers";
import { RouteNames } from "../../../providers/routeNames";
import { ImageSets } from "../../../../../shared/utils/imageSets";

@Component({ template: '' })
export abstract class BaseCodeDisplayStyleComponent extends BaseComponent {

  @Input()
  subHeading: string;

  @Input()
  codeValue: AbstractCodeValue;
  
  @Input()
  panelId: number;

  @Input()
  isStored: boolean = false;

  panel: CodePanel;
  
  isSummary: boolean = false;

  configurationId: number;

  confSessionId: number;

  public imageSet: string;

  constructor(public productStore: ProductDataStore, public pageStore: PageStore, public confPageSession: ConfPageSessionService) {
    super();
  }

  ngOnInit() {

    this.imageSet = this.getImageSet(this.pageStore.activeRouteName === RouteNames.Editor ? ImageSets.ConfiguratorPanel : ImageSets.SummaryActionDetail);

    this.panel = this.productStore.getEntity(this.panelId);
    this.configurationId = this.confPageSession.activeConfigurationId;
    this.confSessionId = this.confPageSession.confSessionId;
    
    super.ngOnInit();
  }

}